import { Component, input, TemplateRef, viewChild } from '@angular/core';

@Component({
  selector: 'ideals-tab',
  standalone: true,
  template: '<ng-template><ng-content/></ng-template>',
})
export class TabComponent {
  readonly label = input.required<string>();
  readonly dataIdeals = input('', { alias: 'data-ideals' });
  readonly template = viewChild.required(TemplateRef);
}
